export const buildPrintHTML = (
  bodyHTML,
  title = "Báo giá",
  { regularFontBase64 = "", boldFontBase64 = "" } = {},
) => {
  const exportedDate = new Date().toLocaleDateString("vi-VN");
  const embeddedFonts = `
    ${
      regularFontBase64
        ? `@font-face{
            font-family:"Quotation Serif";
            src:url("${regularFontBase64}") format("truetype");
            font-weight:400;
            font-style:normal;
          }`
        : ""
    }
    ${
      boldFontBase64
        ? `@font-face{
            font-family:"Quotation Serif";
            src:url("${boldFontBase64}") format("truetype");
            font-weight:600 900;
            font-style:normal;
          }`
        : ""
    }
  `;

  return `<!doctype html>
<html lang="vi">
<head>
  <meta charset="utf-8"/>
  <title>${title}</title>
  <style>
    ${embeddedFonts}
    :root{--page-w:794px;--page-h:1123px;}
    *{
      box-sizing:border-box;
      margin:0;
      padding:0;
      font-family:"Quotation Serif","Times New Roman",Times,serif !important;
    }
    html,body{background:#fff;color:#111;font-family:"Quotation Serif","Times New Roman",Times,serif}
    @page{size:794px 1123px;margin:0}
    body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}
    .pdf-root{
      position:relative;
      z-index:1;
      width:var(--page-w);
      min-height:var(--page-h);
      margin:0 auto;
      padding:40px 48px;
      line-height:1.45;
      font-size:13px;
    }
    table{width:100%;border-collapse:collapse;font-size:11px;margin-top:18px}
    thead{display:table-header-group}
    tr{break-inside:avoid;page-break-inside:avoid}
    th,td{border:1px solid #222;padding:7px 7px;vertical-align:middle}
    th{font-weight:700;color:#000;text-align:center;background:#fff}
    a{color:#0267FF;text-decoration:none}
    .text-center{text-align:center}
    .text-right{text-align:right}
    .col-index{width:44px}
    .col-quantity{width:48px}
    .col-vat{width:54px}
    .col-money{width:104px}
    .service-main-row td{padding-top:9px;padding-bottom:9px;font-weight:600}
    .service-detail-row td{font-size:10px}
    .service-detail-row td:nth-child(2){padding-left:18px}
    .additional-fee-row td:nth-child(2){font-style:italic}
    .vat-note{margin-top:2px;font-size:8px;color:#444;font-weight:400}
    .adjustment-section{margin-top:14px;page-break-inside:avoid}
    .adjustment-title{margin-bottom:6px;font-size:12px;font-weight:700}
    .adjustment-table{margin-top:0;font-size:11px}
    .adjustment-table th,.adjustment-table td{padding:7px;white-space:pre-wrap}
    .adjustment-index-col{width:44px}
    .adjustment-type-col{width:130px}
    .adjustment-amount-col{width:140px}
    .wm-overlay-fixed{
      position:fixed;
      inset:0;
      padding:30px 52px;
      background-size:95%;
      background-repeat:no-repeat;
      background-position:center;
      background-origin:content-box;
      opacity:0.12;
      pointer-events:none;
      z-index:999999;
    }
    .heading{
      text-align:center;
      font-size:20px;
      font-weight:700;
      color:#000;
      padding-bottom:8px;
      margin-bottom:18px;
    }
    .info-section{
      padding:0;
      margin-bottom:16px;
    }
    .info-row{display:flex;margin-bottom:4px}
    .info-row:last-child{margin-bottom:0}
    .info-label{font-weight:700;width:112px;color:#000}
    .info-value{color:#000}
    .info-link{font-weight:600}
    .summary-section{
      padding:0;
      margin-top:16px;
      page-break-inside:avoid;
    }
    .summary-row{display:flex;justify-content:space-between;margin-bottom:7px;font-size:12px}
    .summary-label,.summary-value{font-weight:600;color:#000}
    .total-row{display:flex;justify-content:space-between;padding-top:4px;margin-top:4px}
    .total-label{font-size:14px;font-weight:700;color:#000}
    .total-amount{font-size:17px;font-weight:700;color:#000}
    .quotation-footer{
      margin-top:26px;
      text-align:center;
      font-size:10px;
      line-height:1.35;
      color:#333;
      page-break-inside:avoid;
    }
  </style>
</head>
<body>
  <div class="pdf-root">
    ${bodyHTML}
    <div class="quotation-footer">
      <p>Báo giá được xuất ngày ${exportedDate} từ Nền tảng số Sohuutritue.vn</p>
      <p>Tổng đài tư vấn Sở hữu trí tuệ: <a href="tel:0819009697">08 1900 9697</a> (điện thoại, zalo) - Email: <a href="mailto:luatsu@sohuutritue.vn">luatsu@sohuutritue.vn</a></p>
    </div>
  </div>
  <div class="wm-overlay-fixed"></div>
</body>
</html>`;
};
